import { If } from '@JSX';
import { Button, Buttons } from '@mosanic/fields/Button/Buttons';
import { AdvancedLabel, ControlDialog } from '@mosanic/items';

import { closeModal, confirmModalAction, declineModalAction } from '@redux/modal/action';
import { getModalSelector } from '@redux/modal/reducer';
import { useDispatch, useSelector } from 'react-redux';


const BuilderConfirm = () => {
    const modal = useSelector(getModalSelector)
    const dispatch = useDispatch();

    const close = () => dispatch(closeModal);
    const confirm = () => dispatch(confirmModalAction());
    const decline = () => dispatch(declineModalAction());

    return (
        <ControlDialog 
            state={Boolean(modal?.message)} 
            close={close}
            size="xs"
            fullWidth={modal?.fullWidth}
        > 
            <If condition={ modal?.title }>
                <h3>
                    {modal.title}
                </h3>
            </If>
           <AdvancedLabel size="large">
                {modal.message}
           </AdvancedLabel>

            <Buttons mt={4}>
                <Button handler={confirm}>
                    Confirm
                </Button>
                <Button handler={decline} variant="decline">
                    Decline
                </Button>
            </Buttons>
            
        </ControlDialog>
    );
};
export default BuilderConfirm;